import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=37b153b8&scoped=true"
import script from "./subscription.vue?vue&type=script&lang=js"
export * from "./subscription.vue?vue&type=script&lang=js"
import style0 from "./subscription.vue?vue&type=style&index=0&id=37b153b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b153b8",
  null
  
)

export default component.exports